import { useState } from "react";
import { imgUrl } from "@/lib/api";

const initials = (name = "") => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

export const ShopLogo = ({ shop, className = "h-14 w-14 rounded-xl", testid }) => {
  const [broken, setBroken] = useState(false);
  if (shop.logo && !broken) {
    return <img src={imgUrl(shop.logo)} alt={shop.name} data-testid={testid} onError={() => setBroken(true)} className={`shrink-0 bg-white object-contain p-1 ring-1 ring-gray-200 ${className}`} />;
  }
  return (
    <div data-testid={testid ? `${testid}-initials` : undefined} aria-label={shop.name} className={`flex shrink-0 items-center justify-center bg-gradient-to-br from-orange-500 to-amber-500 font-display font-black text-white ${className}`}>
      {initials(shop.name)}
    </div>
  );
};
